const de = {
  alerts: {
    servicesDownTitle: 'Service-Einschränkungen',
    servicesDown:
      'Einige Services stehen zur Zeit nicht zur Verfügung. Die Benutzererfahrung könnte dadurch z.T. eingeschränkt sein.'
  },
  categories: {
    ARTICLE: 'Beitrag',
    BULLETIN: 'Schwarzes Brett',
    EVENT: 'Veranstaltung',
    FUNDING: 'Förderung',
    JOB_OFFER: 'Stellenangebot',
    STUDENT_OFFER: 'Stellengesuch',
    MODULE_SELECTION: 'Wahl',
    COMPANY: 'Firma'
  },
  menu: {
    dashboard: 'Dashboard',
    watchlist: 'Merkliste',
    titleAWPM: 'AWPM Wahl',
    titleFWPM: 'FWPM Wahl',
    jobmarket: 'Stellenmarkt',
    internationalOffice: 'International Office',
    jobs: 'Stellenangebote',
    myJobApplications: 'Meine Stellengesuche',
    studentApplications: 'Stud. Stellengesuche',
    manageCompanies: 'Firmenverwaltung',
    manageJobs: 'Stellenverwaltung',
    manageMyJobs: 'Meine Stellen',
    myCompany: 'Meine Firma',
    myInvoices: 'Meine Rechnungen',
    settings: 'Einstellungen',
    settingsJobmarket: 'Stellenmarkt Einstellungen',
    settingsArticles: 'Berechtigungseinstellungen',
    settingsMessaging: 'Benachrichtigungseinstellungen',
    settingsInternationalOffice: 'International Office Einstellungen',
    articles: 'Beiträge',
    billing: 'Rechnungsdaten',
    billingApprove: 'Rechnungsfreigabe',
    billingExport: 'Rechnungsexport',
    polyas: 'Polyas',
    calendar: 'Kalender',
    gki: 'gKI-Dienst',
    chat: 'Chat',
    gKIchat: 'gKI-Chat',
    apiKeys: 'API-Schlüssel',
    community: 'Community',
    bulletinBoard: 'Schwarzes Brett',
    links: 'Links',
    manageInvoices: 'Rechnungen verwalten',
    profile: 'Profil',
    leihbar: 'leihBar',
    leihbarHome: 'Katalog',
    leihbarProfile: 'Verleiher-Profil',
    leihbarDaily: 'Tagesanzeige',
    leihbarStatistics: 'Statistik',
    leihbarAccess: 'Bereichszuordnung',
    shibUserManagement: 'Shibboleth Nutzer',
    testUserManagement: 'Test Nutzer',
    settingsSystemNotifications: 'Systembenachrichtigungseinstellungen',
    moduleSelections: 'Wahlübersicht',
    modules: 'Modulkatalog',
    groupings: 'Gruppierungen',
    temporarilyDisabled:
      'Dieser Bereich wird derzeit überarbeitet und steht demnächst wieder zur Verfügung.',
    accessHandler: 'Zugangskontrolle',
    activityLog: 'Aktivitäten Log',
    pricingtable: 'Preisliste',
    events: 'Veranstaltungen',
    eventsSettings: 'Veranstaltungseinstellungen',
    dashboardCardSettings: 'Kacheleinstellungen',
    other: 'Sonstiges'
  },
  desktopOnly:
    'Diese Ansicht ist nicht für Mobilgeräte optimiert. Um sie zu sehen, rufen Sie sie bitte auf einem Desktop auf.',
  profile: {
    markAsRead: 'Als gelesen markieren',
    markAllAsRead: 'Alle als gelesen markieren',
    view: 'Ansehen'
  }
};
export default de;
export type LayoutTranslation = typeof de;
